export const getFromStorage = (key) => JSON.parse(window.localStorage.getItem(key));

export const writeToStorage = (key, value) => window.localStorage.setItem(key, JSON.stringify(value));

export const existInStorage = (key) => window.localStorage.getItem(key) !== null;

export const LocalStorage = {
  get(key) {
    return getFromStorage(key);
  },
  set(key, value) {
    writeToStorage(key, value);
  },
  remove(key) {
    window.localStorage.removeItem(key);
  },
};
